import { Box } from '@mui/material'
import AdxPopper from 'components/reusable/AdxPopper'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { deleteJobAds } from 'services/api/modules/recruitment/job-advertisment'
import useOpenClose from 'services/hooks/useOpenClose'
import ViewJobAdsDialog from './ViewJobAdsDialog'

const DraftPopper = ({ id }) => {
  //navigate
  const navigate = useNavigate()
  const goToManagePublisDraftJobAds = () => {
    navigate(`/app/recruitment/applicant-tracking/job-ads/${id}/draft`, {
      state: {
        id,
      },
    })
  }
  // modal
  const deleteModal = useOpenClose(false)
  const updateModal = useOpenClose(false)
  const viewJobAdsModal = useOpenClose(false)
  const deleteSucess = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)

  // API CALL
  const queryClient = useQueryClient()
  const {
    isLoading: deleteLoading,
    isSuccess: deleteIsSuccess,
    error: deleteError,
    mutate: deleteMutate,
  } = useMutation((id) => deleteJobAds(id), {
    onSuccess: async () => {
      queryClient.resetQueries('getAllJobAds')
      queryClient.invalidateQueries('getAllJobAds')
      deleteSucess.handleOpen()
    },
    onError: async (error) => {
      queryClient.invalidateQueries('getAllJobAds')
      errorSnackbar.handleOpen()
    },
  })

  const DeleteJobAdsModal = () => (
    <AdxInfoModal
      variant="error"
      modalWidth={600}
      open={deleteModal.isOpen}
      onClose={deleteModal.handleClose}
      muiIcon="error_icon"
      iconColor="error.main"
      title="Delete job advertisement?"
      subtitle="Are you sure you want to delete the job advertisement? Once deleted, you can no longer retrieve applicants data for this job advertisement"
      footerButtons
      firstBtnLabel={'Delete'}
      firstBtnHandle={() => {
        deleteMutate(id)
      }}
      secondBtnLabel={'Cancel'}
      secondBtnHandle={deleteModal.handleClose}
    />
  )
  return (
    <Box display="flex" alignItems="center" columnGap={2}>
      <AdxPopper placement="bottom-start" sx={{ marginTop: 1 }}>
        <Box onClick={() => goToManagePublisDraftJobAds()}>Manage job</Box>
        {/* <Box  onClick={viewJobAdsModal.handleOpen}>
                View Job Ads
              </Box> */}
        {/* <Box onClick={updateModal.handleOpen}>
                Publish job ads
              </Box> */}
        <Box
          sx={{
            color: 'error.main',
          }}
          onClick={deleteModal.handleOpen}
        >
          Delete job
        </Box>
      </AdxPopper>

      {deleteModal.isOpen ? <DeleteJobAdsModal /> : null}

      {viewJobAdsModal.isOpen ? (
        <ViewJobAdsDialog
          id={id}
          handleClose={viewJobAdsModal.handleClose}
          open={viewJobAdsModal.isOpen}
          data
        />
      ) : null}

      {deleteSucess.isOpen ? (
        <SnackbarRecruitment
          status="success"
          autoHideDuration={4000}
          TransitionComponent="slide"
          message="Job advertisement deleted"
          open={deleteSucess.isOpen}
          handleClose={deleteSucess.handleClose}
        />
      ) : null}

      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured. Please try again"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}
    </Box>
  )
}
export default DraftPopper
